import { ReactNode } from 'react';
import { AppFeatures } from './plans';

export enum AppModule {
  LIVE_SHOPPING = 'liveShopping',
  PERSONAL_SHOPPER = 'personalShopper',
  PRODUCTS = 'products',
  BILLING = 'billing',
  EXTERNAL_BILLING = 'externalBilling',
  CONFIG = 'config',
  SETTINGS = 'settings',
  USERS = 'users',
  ACCOUNT_MANAGEMENT = 'accountManagement',
}

export type AppMenuItem = {
  title: string;
  icon?: string;
};

export type AppRoute = {
  path: string;
  element: ReactNode;
  index?: boolean;
  module?: AppModule;
  menu?: AppMenuItem;
  enableUsingFeaturePlan?: AppFeatures;
};

export type EventCollectionSelectOption = {
  label: string;
  value: any;
};
